import styles from './Pagination.module.scss';

interface Props {
  page: number;
  totalPages: number;
  totalRows: number;
  onPage: (p: number) => void;
}

export default function Pagination({ page, totalPages, totalRows, onPage }: Props) {
  if (totalPages <= 1) return null;

  // Build page number list with ellipsis
  const pages: (number | '...')[] = [];
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || (p >= page - 2 && p <= page + 2)) {
      pages.push(p);
    } else if (p === page - 3 || p === page + 3) {
      pages.push('...');
    }
  }

  return (
    <div className={styles.pagination}>
      <span className={styles.info}>
        {totalRows.toLocaleString()} rows &nbsp;·&nbsp; Page {page} of {totalPages}
      </span>
      <div className={styles.btns} role="navigation" aria-label="Pagination">
        <button
          className={styles.btn}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          aria-label="Previous page"
        >
          ← Prev
        </button>

        {pages.map((p, i) =>
          p === '...'
            ? <span key={`ellipsis-${i}`} className={styles.ellipsis}>…</span>
            : <button
                key={p}
                className={`${styles.btn} ${p === page ? styles.current : ''}`}
                onClick={() => onPage(p)}
                aria-label={`Page ${p}`}
                aria-current={p === page ? 'page' : undefined}
              >
                {p}
              </button>
        )}

        <button
          className={styles.btn}
          disabled={page >= totalPages}
          onClick={() => onPage(page + 1)}
          aria-label="Next page"
        >
          Next →
        </button>
      </div>
    </div>
  );
}
